<template>
  <div>
    <div v-if="deletedUsers.length > 0">
      <h1>Lista próśb o usunięcie konta</h1>
      <table class="table borderless  ">
        <thead>
          <tr class="tr-table">
            <th scope="col">ID</th>
            <th scope="col">Imię</th>
            <th scope="col">Nazwisko</th>
            <th scope="col">Telefon</th>
            <th scope="col">Rola</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in deletedUsers" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.first_name }}</td>
            <td>{{ item.last_name }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.role }}</td>
            <td>
              <button
                type="button"
                class="btn btn-outline-dark"
                v-on:click="deleteUser(item)"
              >
                X
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="alert alert-danger notFoundListAlert">
      Aktualnie nie ma żadnych próśb o usunięcie konta
    </div>
  </div>
</template>

<script>
export default {
  name: "delete-requests",
  computed: {
    deletedUsers() {
      return this.$store.getters.getDeletedUsers;
    },
  },
  created() {
    this.$store.dispatch("getDeletedUsers");
  },
  data: function() {
    return {};
  },
  methods: {
    deleteUser(item) {
      let body = {
        userId: item.id,
      };
      const confirmed = confirm(
        `Czy na pewno chcesz usunąć użytkownika ${item.firstName} ${item.lastName}?`,
        ""
      );
      if (confirmed) {
        this.$store.dispatch("deleteUser", body);
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
.topform {
  display: flex;
  flex-direction: column;
}
</style>
